/* eslint-disable */
import IStat from "./IStat";
import LayerConfig from "./LayerConfig";
import LayerStyleComplex from "./LayerStyleComplex";
import StyleRule from "./style/StyleRule";

 


export type IndicatorAggregationType = 'count' | 'sum' | 'mean';

export default class Indicator {
    
    attributeName!: string;
    
    labelAttribute!: string;

    /** Attribut numérique à agréger pour chaque section du donut (sum/mean). Ignoré si aggregationType = count. */
    valueAttribute?: string;

    /** Mode de calcul de la valeur de chaque section du donut. */
    aggregationType: IndicatorAggregationType = 'count';

    textContent!: string;

    layer!:LayerConfig;

    textSelectContent!: string;

    colorPalette!: string;

    graphType!: string;

    nbColors!:number

    active = true;

    useColorFromAnalyse=false;

    filterData:any;

    label?: string;

    edit=false;

    stats:any;

    showCenterObject=false;

    currentTextContent:string='';

    currentSelectContent:string='';

    chart:any;

    constructor(input: any = null) {
      if (input) {
        Object.assign(this, input);
      }
      if (!this.aggregationType) {
        this.aggregationType = 'count';
      }
    }

    isGraph():boolean{
      return this.graphType!="textarea";
    }
    isTextArea():boolean{
      return this.graphType=="textarea";
    }

    usesValueAggregation(): boolean {
      return this.aggregationType === 'sum' || this.aggregationType === 'mean';
    }
    
    computeStats(features: any,layer:LayerConfig) {
      if(this.graphType=="minmaxmean"){
        if(features && features.length>0){
          this.stats=this.getMinMaxMeanStats(features, this.attributeName);
        }else{
          this.stats={min:0,max:0,mean:0,count:0,sum:0};
        }
   
      }
      else if(this.graphType=="textarea"){

        this.stats=this.getMinMaxMeanStats(features, this.attributeName);
        this.currentTextContent=this.replaceContent(this.textContent,this.stats);
        
      }
      else{
        if(features && features.length>0){
          if(this.useColorFromAnalyse){
            this.stats=this.getCountStatsBasedOnAnalyse(features, this.attributeName,layer.complexStyle);
          }else{
            this.stats=this.getCountStats(features, this.attributeName);
          }
        }else{
          this.stats=[];
        }
      }
    }

    replaceContent(content:string,stats:any,feature?:any):string{
      console.log(stats);
      content=content.replace('{MAX}',stats.max);
      content=content.replace('{MIN}',stats.min);
      content=content.replace('{MEAN}',stats.mean);
      content=content.replace('{COUNT}',stats.count);
      if(feature){
        content=content.replace('{LABEL}',feature.get(this.labelAttribute));
        content=content.replace('{VALUE}',feature.get(this.attributeName));
      }
      return content;
    }

    private getFeatureNumericValue(item: any): number {
      if (!this.valueAttribute) {
        return 0;
      }
      const raw = item.get(this.valueAttribute);
      const value = Number(raw);
      return Number.isFinite(value) ? value : 0;
    }

    private finalizeAggregatedStat(stat: { title: string; count: number; sum: number; value: number }) {
      if (this.aggregationType === 'sum') {
        stat.value = +stat.sum.toFixed(2);
      } else if (this.aggregationType === 'mean') {
        stat.value = stat.count > 0 ? +(stat.sum / stat.count).toFixed(2) : 0;
      } else {
        stat.value = stat.count;
      }
      // Conservé pour compatibilité avec le rendu existant du donut
      stat.count = stat.value;
      return stat;
    }

    getCountStatsBasedOnAnalyse(features: any, attributeName: string,complexAnalyse:LayerStyleComplex) {
      let stats:any[]=[];
      complexAnalyse.styleRules.forEach((rule:StyleRule)=>{
        stats.push({title:rule.label,count:0,sum:0,value:0});
      });
      features.forEach((item: any) => {
        complexAnalyse.styleRules.forEach((rule:StyleRule,index:number)=>{
          if(rule.evaluateFeature(item)){
            stats[index].count+=1;
            if (this.usesValueAggregation()) {
              stats[index].sum += this.getFeatureNumericValue(item);
            }
          }
        });}  );
      return stats.map((stat) => this.finalizeAggregatedStat(stat));
    }
     getCountStats(features: any, attributeName: string) {
        let productStat = features.reduce((acc: any, item: any) => {
          const key = item.get(attributeName);
    
          if (!acc[key]) {
            acc[key] = { title: key || "", count: 0, sum: 0, value: 0 };
          }
          acc[key].count += 1;
          if (this.usesValueAggregation()) {
            acc[key].sum += this.getFeatureNumericValue(item);
          }
          return acc;
        }, {} as Record<string, { title: string; count: number; sum: number; value: number }>);
    
        productStat = Object.values(productStat).map((stat: any) => this.finalizeAggregatedStat(stat));
        return productStat;
    }
 getMinMaxMeanStats(features: any, attributeName: string):IStat {
    let productStat = features.reduce((acc: any, item: any) => {
      const key = item.get(attributeName);
      let value = Number(key)
      if (!acc["count"]) {
        acc["count"] = 0;
        acc["min"] = value;
        acc["max"] = value;
        acc["sum"] = 0;
        acc["mean"] = 0;
      }
      acc["count"] += 1;
      acc["sum"] += value;
      if (value < acc["min"]) {
        acc["min"] = value;
      }
      if (value > acc["max"]) {
        acc["max"] = value;
      }
      return acc;
    }, {} as Record<string, { title: string; count: number }>);

    productStat.mean = productStat.sum / productStat.count;
    productStat.sum = +productStat.sum.toFixed(2);
    productStat.min = +productStat.min.toFixed(2);
    productStat.max = +productStat.max.toFixed(2);
    productStat.mean = +productStat.mean.toFixed(2);
    return productStat;
  }
    clone() {
      return new Indicator(this.toJson());
    }
    
   

    toJson(): any {
      return {
        attributeName: this.attributeName,
        labelAttribute:this.labelAttribute,
        valueAttribute: this.valueAttribute,
        aggregationType: this.aggregationType || 'count',
        label: this.label,
        useColorFromAnalyse:this.useColorFromAnalyse,
        textContent:this.textContent,
        showCenterObject:this.showCenterObject,
        textSelectContent:this.textSelectContent,
        nbColors:this.nbColors,
        graphType: this.graphType,
        colorPalette: this.colorPalette,
      };
    }
}
